var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1725 8.42249L17.6325 10.8825C18.0225 11.2725 18.6525 11.2725 19.0425 10.8825C19.4325 10.4925 19.4325 9.86249 19.0425 9.47249L15.8725 6.29249C15.6857 6.10523 15.432 6 15.1675 6C14.903 6 14.6493 6.10523 14.4625 6.29249L11.2925 9.47249C10.9025 9.86249 10.9025 10.4925 11.2925 10.8825C11.6825 11.2725 12.3125 11.2725 12.7025 10.8825L15.1725 8.42249ZM15.1725 20.7625L12.7125 18.3025C12.5257 18.1152 12.272 18.01 12.0075 18.01C11.743 18.01 11.4893 18.1152 11.3025 18.3025C10.9125 18.6925 10.9125 19.3225 11.3025 19.7125L14.4725 22.8925C14.8625 23.2825 15.4925 23.2825 15.8825 22.8925L19.0525 19.7225C19.4425 19.3325 19.4425 18.7025 19.0525 18.3125C18.8657 18.1252 18.612 18.02 18.3475 18.02C18.083 18.02 17.8293 18.1252 17.6425 18.3125L15.1725 20.7625Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrows);
export default __webpack_public_path__ + "static/media/selectArrows.29a684a11efeb843297c5c378531a827.svg";
export { ForwardRef as ReactComponent };